exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".results-container[data-v-0ee587be] {\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1050;\n  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.18);\n  max-height: 50vh;\n  overflow: scroll;\n}", ""]);

// exports
